const { REACT_APP_ENDPOINT, REACT_APP_ONPREM_MODE, REACT_APP_NEW_BACKEND, NODE_ENV } = process.env;

// developer toggles
const win = window as any;

// environment
export const isProduction = NODE_ENV === 'production';

// server endpoint. defaults to origin
export const HOST_URL = REACT_APP_ENDPOINT ?? '';
export const isOnPrem = REACT_APP_ONPREM_MODE === 'true' || !!win.onpremVersion;

// all supported apis
export const APIS = {
  APP: '/WebApp',
  GLOBAL: '/WebAppGlobal',
  PLAYBOOKS: '/api/playbooks',
  CUSTOM_REMEDIATION_WEB_API_CALL: '/api/api-actions-integration/templates',
  SSPM: '/sspm',
  GQL: '/gateway/graphql',
  AUTHN: '/authentication'
} as const;

// local storage keys for persistence
export enum ePersistedKeys {
  isLightTheme = 'isLightTheme',
  isSidebarOpen = 'isSidebarOpen',
  selectedOverviewTab = 'selectedOverviewTab'
}

export const isRenderedAsIframeInNewUI = window.self !== window.top;

export const isNewBackend =
  isRenderedAsIframeInNewUI ||
  REACT_APP_NEW_BACKEND === 'true' ||
  !!(typeof win.cynetBackendVersion === 'string' && parseInt(win.cynetBackendVersion) >= 2);

export const globalConfigEnabledFeatures: { [key: string]: boolean } = {
  nodeMicroservicesIntegration: isNewBackend
};

export const isTesting = localStorage.getItem('isTesting') === 'true';
export const testAccessKey = process.env.REACT_APP_TEST_ACCESS_KEY;
